require('./_bootstrap');
require('../../../vendor/menu/bs4-menu');
require('../../../vendor/menu/bs4-menu-init');
require('../../../vendor/menu/bs4-menu-custom');
require('../../../vendor/menu/fd-menu');
require('owl.carousel');

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction()
};

function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("myBtn").style.display = "block";
    } else {
        document.getElementById("myBtn").style.display = "none";
    }
}

// When the user clicks on the button, scroll to the top of the document

document.getElementById("myBtn").addEventListener('click', function () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});

// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

var isPhoneAudit = document.getElementById('audit-phone');
var isSkypeAudit = document.getElementById('audit-skype');

if (isPhoneAudit != null) {
    isPhoneAudit.addEventListener('change', () => {
        if (isPhoneAudit.value.length > 0) {
            document.getElementById('defaultCheck2').required = true;
            document.getElementById('invalidCheck2').required = true;
        } else {
            document.getElementById('defaultCheck2').required = false;
            document.getElementById('invalidCheck2').required = false;
        }

    })
}

if (isSkypeAudit != null) {
    isSkypeAudit.addEventListener('change', () => {
        if (isSkypeAudit.value.length > 0) {
            document.getElementById('defaultCheck3').required = true;
            document.getElementById('invalidCheck2').required = true;
        } else {
            document.getElementById('defaultCheck3').required = false;
            document.getElementById('invalidCheck2').required = false;
        }

    })
}

let contactSelect = document.getElementById('contact-select');
if (contactSelect != null) {
    contactSelect.addEventListener('change', () => {

        let url = contactSelect.options[contactSelect.selectedIndex].value;
        if (url !== "show-me-form") {
            window.location.replace(url);
        } else {
            document.getElementById('contact-form').classList.remove('d-none');
        }
    });
}

let auditCheckPhone = document.getElementById('defaultCheck2');
let auditCheckSkype = document.getElementById('defaultCheck3');
let rgpdBlock = document.getElementById('rgpdBlock');

if (auditCheckPhone != null || auditCheckSkype != null) {

    auditCheckPhone.addEventListener('change', () => {
        if (rgpdBlock.classList.contains('d-none')) {
            rgpdBlock.classList.remove('d-none');
        } else {
            rgpdBlock.classList.add('d-none');
        }

    });
}

$('#cgv_agreement').on('submit', function(e){
    e.preventDefault();

    const cgvAgreementForm = document.getElementById('cgv_agreement');
    const formData = new FormData(cgvAgreementForm);
    const url = '/espace-client/first-cgv';
    const project_id = formData.get('project_id');
    const user_id = formData.get('user_id');
    const data = {
        userId:user_id,
    };

    $.ajax({
        type: 'POST',
        url: url,
        data: { userId : data.userId, projectId:project_id, _token: formData.get('_token') },
        success: function(result){
            if(result === 'success')
            {
                $(`#modal-cgv-${project_id}`).modal("hide");
                $(`#my_budget_${project_id}`).modal("show");
            }
        },
        error:function (result) {
            console.log(result);
        }
    });
});

let noBudgetCheck = document.getElementById('no_budget_check');
if (noBudgetCheck !=null){
    noBudgetCheck.addEventListener('change', function(){
        document.getElementById('InputBudget').value = null;
        document.getElementById('InputBudget').placeholder='Je n\'ai pas de budget défini';
    });
}

$(document).ready(function(){
    $('.owl-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        navText : ['<i class="fas fa-angle-left" aria-hidden="true"></i>','<i class="fas fa-angle-right" aria-hidden="true"></i>'],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:6
            },
        }
    })
});
